import { ColorKey, ColorPalette, PrimitiveColors, SemanticColorKey, SemanticColors } from './colors';
import { darkTheme } from './darkTheme';
import { lightTheme } from './lightTheme';

// Local Typings
// TODO: This will be removed once we are fully migrated to v3 in favor of NumericFontSize
export const fontSizes = ['heading1', 'heading2', 'heading3', 'heading4', 'body', 'smallBody', 'legal'] as const;

type FontSizes = typeof fontSizes;
export type FontSize = FontSizes[number];
export type NumericFontSize =
  | 10
  | 12
  | 14
  | 16
  | 20
  | 24
  | 36
  | 48
  | 64;

export type FontColor = Extract<ColorKey,
  | 'black0'
  | 'black150'
  | 'black200'
  | 'black350'
  | 'black400'
  | 'black500'
  | 'black600'
  | 'blue0'
  | 'blue300'
  | 'blue500'
  | 'blue700'
  | 'brandNavy'
  | 'green0'
  | 'green500'
  | 'green600'
  | 'navy300'
  | 'navy500'
  | 'red0'
  | 'red500'
  | 'red600'
  | 'v3_blue_500'
  | 'v3_blue_600'
  | 'v3_blue_700'
  | 'v3_gray_400'
  | 'v3_gray_600'
  | 'v3_green_700'
  | 'v3_navy_600'
  | 'v3_navy_700'
  | 'v3_navy_900'
  | 'v3_red_400'
  | 'v3_red_700'
  | 'v3_white_100'
  | 'v3_yellow_700'
  | 'yellow0'
  | 'yellow600'
> | SemanticColorKey;

interface MediaQueries {
  lg: {
    max: string;
    min: string;
  };
  md: {
    max: string;
    min: string;
  };
  sm: {
    max: string;
    min: string;
  };
  xs: {
    max: string;
  };
}

type ThemeFontSizes = Record<FontSize, number>;
interface Sizes {
  fontSizes: ThemeFontSizes;
}
interface Components {
  button: {
    borderRadius: number;
    size: {
      lg: number;
      md: number;
      sm: number;
    };
  };
  form: {
    fieldGapX: number;
    fieldGapY: number;
  };
  global: {
    brandBoxShadow: string;
    hoverBoxShadow: string;
  };
  mediaQueries: MediaQueries;
}

type ThemeVariant = 'dark' | 'light';

export interface Theme {
  /**
   * @deprecated Use `semanticColors` instead
   */
  colors: ColorPalette;
  components: Components;
  mode: ThemeVariant;
  primitiveColors: PrimitiveColors;
  semanticColors: SemanticColors;
  sizes: Sizes;
  spacing: number;
}

export const themes: Record<ThemeVariant, Theme> = {
  dark: darkTheme,
  light: lightTheme,
};

// This could potentially be used to calculate theme dynamically
export const getTheme = () =>
  themes.light;
